module.exports = __webpack_public_path__ + "static/img/ttr05.b73533a.png";